/**
 * @fileoverview Uma leitura da API com a situação dela: "loading", "ready" ou
 * "error" (a tela mostra o carregando ou o "Tentar de novo", nunca uma lista
 * vazia que não foi confirmada), e `pending` enquanto relê (os dados de antes
 * continuam à vista). `reload` lê de novo; uma resposta que chega depois de
 * outra mais nova, ou depois de a tela fechar, é ignorada.
 */

import { useCallback, useEffect, useRef, useState } from "react";

const useRequest = (load, deps) => {
  const [state, setState] = useState({ data: null, status: "loading", pending: true });
  const latest = useRef(0);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const run = useCallback(load, deps);

  const reload = useCallback(() => {
    latest.current += 1;
    const id = latest.current;
    setState((prev) => ({ ...prev, status: prev.data ? prev.status : "loading", pending: true }));
    return run()
      .then((data) => {
        if (latest.current === id) setState({ data, status: "ready", pending: false });
        return data;
      })
      .catch(() => {
        if (latest.current === id) {
          setState((prev) => ({ ...prev, status: prev.data ? prev.status : "error", pending: false }));
        }
        return null;
      });
  }, [run]);

  useEffect(() => {
    reload();
    return () => {
      latest.current += 1;
    };
  }, [reload]);

  return { ...state, reload };
};

export default useRequest;
